import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M11 13L22 2M22 2H14M22 2V10M9 2H2V22H22V15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=external-link.js.map
